__turbopack_context__.v({
  "caption": "kw1oyW_caption",
  "figure": "kw1oyW_figure",
});
